import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import FoldersTab from '../../components/File/FoldersTab'
import { ExternalContainerFoldersQuery } from '../../__generated__/ExternalContainerFoldersQuery.graphql'
import useLazyLoadQueryWithSubscription from '../../hooks/useLazyLoadQueryWithSubscription'

const ExternalContainerFolders: React.FC<{ slug: string }> & { Skeleton: React.FC } = ({ slug }) => {
  const queryData = useLazyLoadQueryWithSubscription<ExternalContainerFoldersQuery>(
    containerQuery,
    { slug },
    { subscriptionOptions: { entityType: 'containers', entitySlug: slug } }
  )

  return <FoldersTab folders={queryData.containerShow.folders} entityType='containers' entitySlug={slug} />
}

const containerQuery = graphql`
  query ExternalContainerFoldersQuery($slug: String!) {
    containerShow(slug: $slug) {
      folders {
        ...FoldersTab_folders
      }
    }
  }
`

ExternalContainerFolders.Skeleton = () => <FoldersTab.Skeleton />

export default ExternalContainerFolders
